import type { OTPForm } from '#/shared/forms/otp';
import type { UserForm } from '#/shared/forms/user';
import type { AuthForm } from '#/shared/forms/auth';

import React from 'react';
import { observer } from 'mobx-react';
import { dispatch } from 'rfx-core';
import { Grid, Message, Segment, Button } from 'semantic-ui-react';
import { Link } from 'react-router';

import { useStores } from '#/shared/hooks/useStores';
import { colors } from '#/ssm-ui';

import AuthFormOTP from './form/AuthOTP';
import AuthFormRegister from './form/AuthRegister';
import AuthFormLogin from './form/AuthLogin';

const handleShowSigninSection = () =>
  dispatch('ui.auth.toggleSection', 'signin');

const handleShowSignupSection = () =>
  dispatch('ui.auth.toggleSection', 'signup');

const AuthenticationForm = observer(
  ({
    forms,
    isModal,
  }: {
    forms: { login: AuthForm; otp: OTPForm; register?: UserForm };
    /** @deprecated Modal has been removed */
    isModal?: boolean;
  }) => {
    const { ui } = useStores();

    const { showSection } = ui.auth;

    return (
      <Grid
        className="auth-form"
        style={{ height: '100%' }}
        textAlign="center"
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: 450 }}>
          <Segment basic={true} className="dn">
            <Button.Group>
              <Button
                attached="left"
                basic={showSection !== 'signin'}
                onClick={handleShowSigninSection}
                primary={true}
              >
                <span className="pr3">Login</span>
              </Button>
              <Button.Or />
              <Button
                attached="right"
                basic={showSection !== 'signup'}
                onClick={handleShowSignupSection}
                primary={true}
              >
                <span className="pl3">Register</span>
              </Button>
            </Button.Group>
          </Segment>
          <Segment basic={isModal} padded={true}>
            {showSection === 'signin' && <AuthFormLogin form={forms.login} />}
            {showSection === 'signup' && (
              <AuthFormRegister form={forms.register} />
            )}
            {showSection === 'otp' && <AuthFormOTP form={forms.otp} />}
          </Segment>
          {showSection === 'signin' && (
            <Message>
              <Link
                style={{ color: colors['text-clickable'] }}
                to="/password/forgot"
              >
                Forgot Password
              </Link>
            </Message>
          )}
        </Grid.Column>
      </Grid>
    );
  },
);

AuthenticationForm.displayName = 'AuthenticationForm';
export default AuthenticationForm;
